"use client";

import { Fragment } from "react";
import { Check, ChevronsUpDown, GalleryVerticalEnd } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { useRole } from "@/contexts/role-context";

export function TeamSwitcher() {
  const { isMobile } = useSidebar();
  const { roleConfig, entityOption, entityOptionId, setEntityOption } = useRole();

  if (!entityOption) {
    return null;
  }

  const ActiveIcon = entityOption.icon ?? GalleryVerticalEnd;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
                <ActiveIcon className="size-4" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{entityOption.typeTitle}</span>
                <span className="truncate text-xs">{entityOption.displayName}</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-60 rounded-lg"
            align="start"
            side={isMobile ? "bottom" : "right"}
            sideOffset={4}
          >
            {roleConfig.entity.groups.map((group, index) => (
              <Fragment key={group.label}>
                <DropdownMenuLabel className="px-2 text-xs font-medium text-muted-foreground">
                  {group.label}
                </DropdownMenuLabel>
                {group.options.map((option) => {
                  const OptionIcon = option.icon ?? ActiveIcon;
                  const isActive = option.id === entityOptionId;
                  return (
                    <DropdownMenuItem
                      key={option.id}
                      onClick={() => setEntityOption(option.id)}
                      className="gap-2 p-2"
                      data-active={isActive}
                    >
                      <div className="flex size-6 items-center justify-center rounded-md border">
                        <OptionIcon className="size-3.5 shrink-0" />
                      </div>
                      <span className="flex-1 truncate">{option.label}</span>
                      {isActive ? <Check className="size-4 text-primary" /> : null}
                    </DropdownMenuItem>
                  );
                })}
                {index < roleConfig.entity.groups.length - 1 ? (
                  <DropdownMenuSeparator className="my-1" />
                ) : null}
              </Fragment>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
